// 名师工作室页面
import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MD5 from 'js-md5'
import styles from './MSInfoPage.module.css'
import {
  Button,
  ConfigProvider,
  Divider,
  Flex,
  message,
  Rate,
  Tabs,
  Modal,
  Image,
} from 'antd'
import teacherImg from './teacherImg.svg'
import {
  addResClickNumRequest,
  getTeacherResRequest,
  getVideoPlayerAuthRequest,
} from './MSGZSListApi'
import Aliplayer from 'aliyun-aliplayer'
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css'
import VideoItem from './VideoItem'
import FileItem from './FileItem'
import BotItem from './BotItem'
import { HTTP_URL } from '../../../util/constants'
import { setShowPlayerModalStatus, setVideoId } from '../../PlayerModal/PlayerModalSlice'
import Cookies from 'js-cookie';
var player

export default function MSInfoPage(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const [tabKey, setTabKey] = useState(1)
  const [showVideo, setShowVideo] = useState(false)
  const [videoList, setVideoList] = useState([])
  const [fileList, setFileList] = useState([])
  const [botList, setBotList] = useState([])

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    getTeacherRes()
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function getTeacherRes() {
    console.log(props.info)
    getTeacherResRequest(props.info.username, (data) => {
      console.log(data)
      if (data.ret == 1) {
        setVideoList(data.data.video_list)
        setFileList(data.data.file_list)
        setBotList(data.data.coze_list)
      } else {
        message.warning(data.msg)
      }
    })
  }
  const tabItems = [
    {
      key: '1',
      label: '教学视频',
    },
    {
      key: '2',
      label: '精选课件',
    },
    {
      key: '3',
      label: '名师智能体',
    },
  ]
  function onChange(params) {
    setTabKey(params)
  }

  const handleCancel = () => {
    setShowVideo(false)
    if (player) {
      player.pause()
    }
  }

  function playVideo(info) {
    addResClickNumRequest(info.code, '1', (data) => {
      if (data.ret == 1) {
        let tempList = videoList.map((item) => {
          if (item.code == info.code) {
            item.video_play_num = parseInt(item.video_play_num) + 1
          }
          return item
        })
        setVideoList(tempList)

        let videoUrl = info.video_id
        if (videoUrl) {
          dispatch(setShowPlayerModalStatus(true))
          dispatch(setVideoId(videoUrl))
        }
      } else {
        message.warning(data.msg)
      }
    })
  }

  function downLoadFile(info) {
    addResClickNumRequest(info.code, '2', (data) => {
      if (data.ret == 1) {
        let tempList = fileList.map((item) => {
          if (item.code == info.code) {
            item.file_downlaod_num = parseInt(item.file_downlaod_num) + 1
          }
          return item
        })
        setFileList(tempList)
        window.open(info.file_url)
      } else {
        message.warning(data.msg)
      }
    })
  }
  const clickBotItem = (info) => {
    window.open(
      HTTP_URL +
        `gongju/preview/index.html?botId=${info.bot_id}&icon=${btoa(info.icon_url)}&title=${info.bot_name}&userToken=${Cookies.get("userToken")}`,
    )
    let tempList = botList.map((item) => {
      if (item.bot_id == info.bot_id) {
        item.open_time = parseInt(item.open_time) + 1
      }
      return item
    })
    setBotList(tempList)
  }
  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      {/* <HeaderBar
        // searchInputChange = {searchInputChange}
        createBot={createBotMethod}
      /> */}
      {/* <div>&lt;&lt;名师工作室</div> */}
      <div className={styles.title}>
        名师工作室
        <span className={styles.backButton} onClick={props.close}>
          返回上一级 &lt;&lt;
        </span>
      </div>
      <div className={styles.WhiteBox}>
        <div className={styles.topBox}>
          {/* <Image className={styles.teacherImg} src={props.info.image_url} /> */}
          {/* <Image
            className={styles.teacherImg}
            // height={300}
            width={300}
            style={{ borderRadius: 8 }}
            src={props.info.image_url}
          /> */}
          <div className={styles.teacherImg}>
            <Image
              // width={125}
              width={300}
              height={390}
              alt="logo"
              src={props.info.image_url}
              style={{ borderRadius: 12, objectFit: 'cover' }}
            />
          </div>

          <div className={styles.teacherInfo}>
            <div className={styles.nameBox}>
              {/* <text className={styles.name}>郝石佩</text>
                            <Divider type="vertical" style={{borderColor:"black"}}/>
                            <text>Hao Shipei</text> */}
              <div className={styles.name}>{props.info.name}</div>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: '#2772F0',
                    colorBgContainer: '',
                    groupTitleFontSize: 28,
                  },
                  components: {
                    Rate: {
                      starSize: 18,
                      starColor: '#ffce73',
                    },
                  },
                }}
              >
                <Rate
                  disabled={true}
                  defaultValue={props.info.star}
                  style={{ marginLeft: 30 }}
                  starSize={2}
                />
              </ConfigProvider>
            </div>
            <div className={styles.teacherInfoList}>
              <ul>
                {JSON.parse(props.info.personal_honor).map((item, index) => (
                  <li key={index}>{item.title}</li>
                ))}
              </ul>
            </div>
            <div className={styles.grjjTitle}>个人简介</div>
            <pre className={styles.grjjDes}>{props.info.personal_profile}</pre>
          </div>
        </div>
        <Tabs
          defaultActiveKey="1"
          items={tabItems}
          onChange={onChange}
          style={{ marginLeft: 50, marginTop: 70 }}
        />
        {tabKey == 1 ? (
          <div className={styles.bottomBox}>
            {videoList.map((item, index) => (
              <VideoItem key={index} info={item} playVideo={playVideo} />
            ))}
          </div>
        ) : null}
        {tabKey == 2 ? (
          <div className={styles.bottomBox}>
            {fileList.map((item, index) => (
              <FileItem key={index} info={item} downLoadFile={downLoadFile} />
            ))}
          </div>
        ) : null}
        {tabKey == 3 ? (
          <div className={styles.bottomBox}>
            {botList.map((item, index) => (
              <BotItem key={index} info={item} clickBotMethod={clickBotItem} />
            ))}
          </div>
        ) : null}
      </div>
      <Modal
        open={showVideo}
        // onOk={handleOk}
        onCancel={handleCancel}
        width={'50%'}
        footer={null}
      >
        <div className={styles.videoTag} id="player0"></div>
      </Modal>
    </div>
  )
}
